import httpClient from "./httpClient";
import {
  AUTH_RECRUITER_EMAIL_LOGIN,
  AUTH_RECRUITER_GOOGLE_LOGIN,
  AUTH_ME,
} from "./endpoints";

const normalizeError = (error) => {
  if (error?.response) {
    const { status, data } = error.response;
    return {
      success: false,
      status,
      title: data?.title || "Error",
      message: data?.message || "Something went wrong. Please try again later.",
      raw: data,
    };
  }

  return {
    success: false,
    status: 0,
    title: "Network Error",
    message: "Unable to reach server. Please check your connection.",
    raw: null,
  };
};

export async function loginRecruiterWithEmail(payload) {
  try {
    const res = await httpClient.post(AUTH_RECRUITER_EMAIL_LOGIN, payload);
    return res.data;
  } catch (error) {
    return normalizeError(error);
  }
}

export async function loginRecruiterWithGoogle(payload) {
  try {
    const res = await httpClient.post(AUTH_RECRUITER_GOOGLE_LOGIN, payload);
    return res.data;
  } catch (error) {
    return normalizeError(error);
  }
}

export async function getCurrentUser() {
  try {
    const res = await httpClient.get(AUTH_ME);
    return res.data;
  } catch (error) {
    return normalizeError(error);
  }
}
